/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['square-experiments'] || ($protobuf.roots['square-experiments'] = new $protobuf.Root());
$root.addJSON({
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "experiments": {
                "nested": {
                  "message": {
                    "nested": {
                      "Status": {
                        "values": {
                          "UNKNOWN": 0,
                          "SUCCESS": 1,
                          "SDK_ERROR": 2,
                          "INVALID_EXPERIMENT_REQUEST": 3,
                          "EXPERIMENT_NOT_FOUND": 4,
                          "VARIANT_NAME_MISMATCH": 5,
                          "IMPRESSION_LIMIT_EXCEEDED": 6,
                          "USER_NOT_IN_EXPERIMENT": 7
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE Status @ squareup/feature/relay/experiments/message/status.proto at 8:1
 */
export const Status = $root.lookupEnum('squareup.feature.relay.experiments.message.Status').values;